export default function IconPlay() {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.38625 1.46333L3.38638 1.4634L10.824 5.56294L10.824 5.56296C11.4099 5.88595 11.8333 6.38471 11.8333 6.99964C11.8333 7.61458 11.4099 8.11331 10.824 8.43624L3.38642 12.5357C3.3864 12.5357 3.38639 12.5357 3.38638 12.5357C2.79577 12.8613 2.151 12.9481 1.62069 12.6529C1.08345 12.3537 0.833252 11.758 0.833252 11.0893L0.833254 2.91086C0.833254 2.24177 1.08334 1.64583 1.62064 1.34658C2.15096 1.05122 2.79572 1.13808 3.38625 1.46333Z" fill="currentColor" stroke="currentColor" />
    </svg>
  );
}
